var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkDeleteAp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.724 6.5A8.724 8.724 0 0 0 6 15.224v10.552a8.724 8.724 0 0 0 8.724 8.724h10.552A8.724 8.724 0 0 0 34 25.776v-7.914h-2v7.914a6.724 6.724 0 0 1-6.724 6.724H14.724A6.724 6.724 0 0 1 8 25.776V15.224A6.724 6.724 0 0 1 14.724 8.5h7.914v-2h-7.914zM16 20.017a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm-.139 3.79a1 1 0 0 0-1.724 1.013l2.002 3.408a1 1 0 0 0 1.724-1.013l-2.002-3.408zM25 10.5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8z",
    fill: "#A12512"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkDeleteAp);
export default __webpack_public_path__ + "static/media/bulkDeleteAP.1c81e562282d83781975c1aa93416420.svg";
export { ForwardRef as ReactComponent };